"use client"

import Image from "next/image";
import type {StaticImport} from "next/dist/shared/lib/get-img-props";
import type {ReactNode} from "react";
import type {Variants} from "framer-motion";
import InViewWrapper from "~/components/layout/InViewWrapper";

interface Props {
  image: StaticImport;
  subtitle: string;
  title: string;
  text: string;
  children?: ReactNode;
  variant?: Variants | null;
}

export default function RightSectionComponent({image, subtitle, title, text, children, variant}: Props) {
  return (
    <section>
      <div className="flex lg:gap-64 gap-16 grow lg:items-center lg:justify-center flex-col lg:flex-row mt-24 overflow-x-hidden">
        {variant ? (
          <InViewWrapper variant={variant} styles={"mx-auto md:w-7/12 w-60 xl:w-8/12 order-2 lg:order-1"}>
            <Image src={image} alt={title} />
          </InViewWrapper>
        ) : (
          <Image src={image} alt={title} className="mx-auto md:w-7/12 w-60 xl:w-4/12 order-2 lg:order-1"/>
        )}

        <div className="order-1 lg:order-2">
          <p className="p mb-3 font-bold text-primary text-[16px]">{subtitle}</p>
          <h1 className="h1 text-primary md:mb-5 mb-2">{title}</h1>
          <p className="text-[16px] mb-7">
            {text}
          </p>
          {children}
        </div>
      </div>
    </section>
  )
}
